import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { UsersService as SharedUsersService } from '@avanta/shared/services/users';
import { type User } from '@avanta/shared/types/users';
import { type AxiosResponse } from 'axios';

const USERS_URL = `${BASE_URL}users`;

interface UserServiceTypes {
  getUser: (userId?: string) => Promise<AxiosResponse<User>>;
  banUser: (userId: string) => Promise<AxiosResponse<void>>;
  setAdminPassword: (userId: string, payload: { password: string }) => Promise<AxiosResponse<void>>;
}

export const UsersService: UserServiceTypes = {
  getUser: SharedUsersService.getUser,
  banUser: async userId => service.delete(`${USERS_URL}/${userId}`, { data: { banned: true } }),
  setAdminPassword: async (userId, payload) =>
    service.post(`${USERS_URL}/${userId}/password/admin`, payload),
};
